export const GET_INVOICES = "GET_INVOICES"
export const GET_INVOICES_PENDING = "GET_INVOICES_PENDING"
export const GET_INVOICES_FAILED = "GET_INVOICES_REJECTED"
export const GET_INVOICES_FULFILLED = "GET_INVOICES_FULFILLED"
